import { render } from "./ShomeiPrecautionsPage.vue?vue&type=template&id=22785aee&scoped=true&ts=true"
import script from "./ShomeiPrecautionsPage.vue?vue&type=script&lang=ts"
export * from "./ShomeiPrecautionsPage.vue?vue&type=script&lang=ts"

import "./ShomeiPrecautionsPage.vue?vue&type=style&index=0&id=22785aee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22785aee"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QField from 'quasar/src/components/field/QField.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QSeparator,QField,QCheckbox,QCardActions,QBtn});
